import ServiceDeBases from "components/Service/ServiceBase";
import React from "react";

function FormInStayPage() {
  return <ServiceDeBases />
}

export default FormInStayPage;
